import { Row } from 'antd';
import { useMemo, useState } from 'react';
import { useCSVReader } from 'react-papaparse';
import { CreateModal } from '../../../../shared/components/Modal';
import { TableInfo } from '../../../../shared/components/Table';
import usePostImportCsv from '../../hooks/usePostImportCsv';

interface CSVImportProps {
  onCancel: () => void;
  visible: boolean;
}

export function CSVImport({ visible, onCancel }: CSVImportProps) {
  const { mutate: salvarCsv, isLoading: LoadingButton} = usePostImportCsv(() => handleCloseLaterSave());
  const { CSVReader } = useCSVReader();

  const [columnData, setColumnData] = useState([]);
  const [rowData, setRowData] = useState([]);

  const columns = useMemo(() => columnData, [columnData]);
  const data = useMemo(() => rowData, [rowData]);

  const dataCSV = data.map((item: any) => ({
    ...item, 
    PercentualDeDesconto: Number(item?.PercentualDeDesconto?.replace(',', '.')),
    ValorUnitario: Number(item?.ValorUnitario?.replace(',', '.')),
    QuantidadeTotal: Number(item?.QuantidadeTotal),
    NumeroNotaFiscal: Number(item?.NumeroNotaFiscal),
    NumeroPedido: Number(item?.NumeroPedido),
  }))

  function handleSaveCsvData(e: any) {
    e.preventDefault();
    salvarCsv(dataCSV);
  }

  function handleCloseLaterSave() {
    onCancel();
    setColumnData([]);
    setRowData([]);
  }

  return (
    <CreateModal
      title="Importar CSV"
      isModalOpen={visible}
      isLoading={LoadingButton}
      onCancel={() => {
        onCancel();
        setColumnData([]);
        setRowData([]);
      }}
      onSubmit={handleSaveCsvData}
    >
      <CSVReader
        onUploadAccepted={(results: any) => {
          const columns = results.data[0].map((col: any, index: number) => {
            return {
              title: col,
              dataIndex: col.split(" ").join("_"),
              key: index,
            }
          });

          const rows = results.data.slice(1).map((row: any, key: number) => {
            return row.reduce((acc: any, curr: any, index: number) => {
              acc[columns[index].dataIndex] = curr;
              const result = { key, ...acc }
              return result;
            }, {});
          })

          setRowData(rows.filter((item: any) => item?.Tipo?.trim()));
          setColumnData(columns);
        }}
      >
        {({
          getRootProps,
          // acceptedFile,
          ProgressBar,
          // getRemoveFileProps,
        }: any) => (
          <>
            <Row style={{
              width: '500px',
              gap: '5px',
            }}>
              <button
                type='button'
                {...getRootProps()}
                style={{ cursor: 'pointer' }}
                className="w-[10rem] h-[2.5rem] mt-[-0.5rem] rounded-sm bg-primary hover:bg-primary-hover text-white"
              >
                Selecionar Arquivo
              </button>
            </Row>
            <ProgressBar />

            <div className={`${data.length > 0 && 'w-[80rem]'} mt-[0.5rem] ${data.length > 10 && 'h-[28rem]'} overflow-hidden overflow-y-auto`}>
              <TableInfo columns={columns} dataSource={data} />
            </div>
          </>
        )}
      </CSVReader>
    </CreateModal>
  );
}
